import { css } from "@emotion/react";
import { ImageOff } from "lucide-react";

// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {
	Autoplay,
	EffectCards,
	EffectCoverflow,
	EffectFade,
	Pagination,
} from "swiper/modules";
import type { SwiperModule } from "swiper/types";
import type { ImmutableObject } from "@/lib/immutable";
import type { PackageItem, Product } from "../../../../hooks/useInventoryState";
import { useStorefrontSettingsState } from "../../../../hooks/useStorefrontSettingsState";

//const mobileImageSize: number = 350;
//const desktopImageSize: number = 512;

/* Image */
export type ProductDetailsPackageItemImageProps = {
	product: ImmutableObject<Product>;
	packageItem: ImmutableObject<PackageItem>;
};
export const ProductDetailsPackageItemImage: React.FC<
	ProductDetailsPackageItemImageProps
> = (props) => {
	//const productDetailsState = useProductDetailsState();
	//const product = productDetailsState.get().product;
	const product = props.product;
	const packageItem = props.packageItem;
	const images = packageItem.Images ?? [];
	//const isDesktop = useMediaQuery(`@media (min-width: ${desktopImageSize + 32}px)`);
	//const itemWidth = isDesktop ? desktopImageSize : mobileImageSize;
	const itemWidth = 96;

	const storefrontSettingsState = useStorefrontSettingsState();
	const swiperModules: SwiperModule[] = [];
	const settings = storefrontSettingsState.get().settings;
	if (settings?.AutoplayImagesOnLandingPage) {
		swiperModules.push(Autoplay);
	}
	swiperModules.push(Pagination);
	swiperModules.push(EffectFade, EffectCards, EffectCoverflow);
	const imagesTransitionEffect =
		storefrontSettingsState.get().settings?.ImagesTransitionEffect ?? "fade";
	const imagesTransitionSpeed =
		parseFloat(
			storefrontSettingsState.get().settings?.ImagesTransitionSpeed ?? "1000",
		) ?? 1000;
	const shouldLoop = images.length > 3;

	if (product) {
		return (
			<div>
				<div
					css={css`
                    display:none;
                    @media print {
                        display: flex;
                        flex-direction: column;
                        justify-content:center;
                    }
                    `}
				>
					{images.map((image, index) => {
						if (index === 0) {
							return (
								<div
									key={image.Id}
									css={css`
                                        display:flex;
                                        align-items:center;
                                        justify-content:center;
                                        flex-wrap: wrap;
                                        `}
								>
									<img
										src={image.Url}
										alt=""
										style={{
											width: `${itemWidth}px`,
										}}
									/>
								</div>
							);
						}
						return null;
					})}
					{(!images || images.length === 0) && (
						<div
							css={css`
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                width: ${itemWidth}px;
                                height: ${itemWidth}px;
                                `}
						>
							<ImageOff
								css={css`flex:1 1 0;width:${itemWidth}px;height:${itemWidth}px;color:#777777;`}
							/>
						</div>
					)}
				</div>

				<div
					className="noprint"
					css={css`
                        flex: 1 1 0; 
                        display: flex;
                        justify-content:center;
                        `}
				>
					<div
						css={css`
                            flex: 0 0 auto;
                            overflow:hidden;
                            max-width: ${itemWidth}px;
                            max-height: ${itemWidth}px;
                        `}
					>
						<Swiper
							speed={imagesTransitionSpeed}
							pagination={{
								dynamicBullets: true,
								type: "bullets",
							}}
							autoplay={{
								delay: 3000,
							}}
							spaceBetween={0}
							grabCursor={true}
							centeredSlides={true}
							centerInsufficientSlides={true}
							slidesPerView={1}
							modules={swiperModules}
							loop={shouldLoop}
							effect={imagesTransitionEffect}
							fadeEffect={{
								crossFade: true,
							}}
						>
							{images.map((image) => (
								<SwiperSlide
									key={image.Id}
									style={{
										width: itemWidth,
										height: itemWidth,
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<img
										src={image.Url}
										alt=""
										style={{
											maxWidth: itemWidth,
											maxHeight: itemWidth,
											width: "auto",
											height: "auto",
										}}
									/>
								</SwiperSlide>
							))}
							{(!images || images.length === 0) && (
								<SwiperSlide>
									<div
										css={css`
                                        display:flex;
                                        align-items:center;
                                        justify-content:center;
                                        width: ${itemWidth}px;
                                        height: ${itemWidth}px;
                                        `}
									>
										<ImageOff
											css={css`flex:1 1 0;width:${itemWidth * 0.75}px;height:${itemWidth * 0.75}px;color:#777777;`}
										/>
									</div>
								</SwiperSlide>
							)}
						</Swiper>
					</div>
				</div>
			</div>
		);
	} else {
		return null;
	}
};
